import { Grid } from '@material-ui/core'
import React, {useState, useEffect} from 'react'
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText'
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect'
import ModalBase from '../../../../../components/Modals/ModalBase'
import DisplayText from '../../../../../components/Texts/DisplayText'
import {formData } from './data'
import SubmitModalButton from '../../../../../components/Buttons/SubmitModalButton'
import {request_update_patient} from '../../requests'
import { onGetInvalidForm, onValidateForm } from '../../../../../shared/utility'

const EditSingleDataModal = props => {

    const {initData, patientID, open, onClose, onUpdatePatient} = props
    const [form, setForm] = useState(null)
    const [error, setError] = useState(null)
    const [valid, setValid] = useState(false)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if(!initData) return
        let initForm = {}
        initData.forEach(item => {
            let singleForm = {...formData[item.id]}
            const value = item.value
            singleForm.value = value
            singleForm.isValid = value !== null && value !== undefined && value !== ""
            singleForm.isVisited =  value !== null && value !== undefined && value !== ""
            initForm = {...initForm, [item.id]:{...singleForm}}
        })
        setForm(initForm)
        setValid(onValidateForm(initForm))

        setError(null)
    }, [initData, open])

    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        setValid(onValidateForm(temp))
        setForm(temp)
    }

    const onEdit = async() => {
        if(!valid){
            setError('Llena los campos faltantes')
            let newForm = onGetInvalidForm(form)
            setForm(newForm)
            return
        }
        let data2send = {}
        Object.keys(form).forEach(item => {
            if((initData[item] !== form[item].value) && form[item].isValid){
                data2send = {...data2send, [item]: form[item].value}
            }
        })

        setLoading(true)
        try {
            const newPatient = await request_update_patient(patientID, data2send)
            setLoading(false)
            onUpdatePatient(newPatient)
            onClose()
        } catch (error) {
            console.log(error)
            setError('Hubo un error')
            setLoading(false)
        }

    }

    let formContent = null

    if(form)
    {
        formContent = Object.keys(form).map((item,key)=>{
            if(item !== 'manual_test'){
                if(form[item].config.type === 'select'){
                    return(
                        <Grid item xs={12}>
                            <LineInputSelect
                                data={form[item]}
                                onChange={onInputChange}/>
                        </Grid>
                    )
                }

                return(
                    <Grid item xs={12} key={key.toString()}>
                            <LineInputText
                            data={form[item]}
                            onChange={onInputChange}/>
                    </Grid>
                )
            }else{
                if(form['test_type_id'].value === 4){
                    return(
                        <Grid item xs={12} key={key.toString()}>
                            <LineInputText
                            data={form[item]}
                            onChange={onInputChange}/>
                        </Grid>
                    )
                }
            }
        })
       /* if(form.config.type === 'select'){
            formContent = (
                <LineInputSelect
                    data={form}
                    onChange={onInputChange}/>
            )
        }else{
            formContent = (
                <LineInputText
                    data={form}
                    onChange={onInputChange}/>
            )
        }*/
    }

    return(
        <ModalBase open={open} onClose={onClose} maxWidth='xs'>
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Información principal</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2} >
                        {formContent}
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <SubmitModalButton error={error} loading={loading} onSubmit={onEdit}/>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default EditSingleDataModal